import { render, staticRenderFns } from "./BaApplyList.vue?vue&type=template&id=2e35b4e3&scoped=true"
import script from "./BaApplyList.vue?vue&type=script&lang=js"
export * from "./BaApplyList.vue?vue&type=script&lang=js"
import style0 from "./BaApplyList.vue?vue&type=style&index=0&id=2e35b4e3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e35b4e3",
  null
  
)

export default component.exports